// extracted by mini-css-extract-plugin
module.exports = {"title":"subTitle_title__3vWaU"};